import { render } from "./AdminHeaderMenu.vue?vue&type=template&id=7b65b67d&scoped=true"
import script from "./AdminHeaderMenu.vue?vue&type=script&lang=js"
export * from "./AdminHeaderMenu.vue?vue&type=script&lang=js"

import "./AdminHeaderMenu.vue?vue&type=style&index=0&id=7b65b67d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b65b67d"]])

export default __exports__